// Third party libraries
import { formatISO, parseISO, format, fromUnixTime } from 'date-fns';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';

export const dateMixins = {
	data() {
		return {
			displayFormat: 'DD-MMM-YYYY'
		}
	},
	computed: {
		userTimezone() {
			return this.$store.getters.getUserDetails.defaultTimezone;
		},
		petBirthDate() {
			return this.$store.getters.getActivePet.birthdate;
		}
	},
	methods: {
		notBeforePetBirthdate(date) {
			return date > parseISO(this.petBirthDate);
		},
		petBirthDateUntilToday(date) {
			return date > new Date() || date < parseISO(this.petBirthDate);
		},
		dateToISO(date) {
			if (!date) {
				return date;
			}

			// convert date to String to prevent replace is not a function errors
			return formatISO(new Date(date.toString().replace(/-/g, ' ')), { representation: 'date' });
		},
		dateToUtc(date) {
			if (!date) {
				return date;
			}

			return format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
		},
		formatDatetoDisplay(date) {
			if (!date) {
				return date;
			}

			return parseISO(date);
		},

		formatDate(date, dateFormat = 'dd-MMM-yyyy') {
			if (!date) {
				return date;
			}

			if (typeof date === 'string') {
				date = new Date(parseISO(date));
			}

			if (typeof date === 'number') {
				date = fromUnixTime(date);
			}

			return this.utcConvertToZonedTime(date, dateFormat);
		},
		formatDateWithoutConversion(date, dateFormat = 'dd-MMM-yyyy') {
			if (!date) {
				return date;
			}

			if (typeof date === 'string') {
				date = new Date(parseISO(date));
			}

			if (typeof date === 'number') {
				date = fromUnixTime(date);
			}

			return format(date, dateFormat);
		},

		formatDateTime(date, dateFormat = 'dd-MMM-yyyy hh:mm a') {
			if (!date) {
				return date;
			}

			if (typeof date === 'string') {
				date = new Date(parseISO(date));
			}

			if (typeof date === 'number') {
				date = fromUnixTime(date);
			}

			return this.utcConvertToZonedTime(date, dateFormat);
		},

		localizedDate(date) {
			const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			date = zonedTimeToUtc(date, timeZone);
			return date;
		},

		utcConvertToZonedTime(date, dateFormat, isUTC) {
			// Get User's Default Timezone
			const utcDate = !isUTC ? this.dateToUtc(date) : date;
			const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			const setFormat = dateFormat ? dateFormat : 'dd-MMM-yyyy';
			const convertedDate = utcToZonedTime(utcDate, timeZone);
			const formattedDate = format(convertedDate, setFormat);
			return formattedDate;
		},

		/**
		 * Converts the date to UTC format
		 * @param {Date} date -  Sun Sep 01 2024 00:00:00 GMT+0800
		 * @returns {String} depositDateUTC - 2024-09-01T00:00:00.000Z
		 */

		convertDateToUTC(date) {
			
			if (!date) {
				return date;
			}

			const newDate = new Date(date);
			// Get the timezone offset in minutes between UTC and the local time
            const offset = newDate.getTimezoneOffset();
			// Subtract the offset from the local time to get the UTC time 
            newDate.setMinutes(newDate.getMinutes() - offset); 
			// Format the date to ISO string and sets the time to midnight
            const depositDateUTC = newDate instanceof Date ? newDate.toISOString().split('T')[0] + 'T00:00:00.000Z' : date;

			return depositDateUTC;
		}
	}
}